export default "__VITE_ASSET__BzRp8CJF__ 300w, __VITE_ASSET__Buww1LIM__ 563w";